import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import * as moment from 'moment';
import { LineupErrorStateMatcher } from '../../services/error-state-matcher.service';

@Component({
  selector: 'daterange',
  templateUrl: 'daterange.component.html',
  styleUrls: ['daterange.component.scss'],
})
export class DateRangeComponent implements OnInit {
  startDate: string = null;
  endDate: string = null;
  present: boolean = false;

  startDateValue = new UntypedFormControl();
  endDateValue = new UntypedFormControl();
  noEndDate = new UntypedFormControl();
  startDatematcher = new LineupErrorStateMatcher();
  endDatematcher = new LineupErrorStateMatcher();

  @Output() dateChanged = new EventEmitter<string>();

  @Input() fieldValue: string;
  @Input() isTouched = false;
  @Input() errorMessage: string;
  @Input() required = false;
  @Input() ariaLabelledby: string;
  @Input() placeholder: string = '';

  constructor() {
    this.startDateValue.valueChanges.subscribe((value) => {
      this.startDateValue.setErrors(null);
      if (value) {
        let validDate = new Date(value);
        this.startDate = moment.utc(validDate).format('MM/DD/YYYY');
        if (!(this.endDate || this.present)) {
          this.endDateValue.setErrors({
            endDateRequired:
              'End Date can not be empty. Please check "Present" if there is no End date',
          });
        }
      } else {
        this.startDate = null;
      }
    });
    this.endDateValue.valueChanges.subscribe((value) => {
      this.endDateValue.setErrors(null);
      if (value) {
        let validDate = new Date(value);
        this.endDate = moment.utc(validDate).format('MM/DD/YYYY');
        if (!this.startDate) {
          this.startDateValue.setErrors({
            startDateRequired: 'Start Date cannot be empty',
          });
        }
      } else {
        this.endDate = null;
        if (!this.present) {
          this.endDateValue.setErrors({
            endDateRequired:
              'End Date can not be empty. Please check "Present" if there is no End date',
          });
        }
      }
    });
    this.noEndDate.valueChanges.subscribe((value) => {
      this.present = value;
      this.endDateValue.setErrors(null);
      this.startDateValue.setErrors(null);
      if (this.present) {
        this.endDateValue.setValue(null);
        if (!this.startDate) {
          this.startDateValue.setErrors({
            startDateRequired: 'Start Date cannot be empty',
          });
        }
      } else {
        if (this.startDate && !this.endDate) {
          this.endDateValue.setErrors({
            endDateRequired:
              'End Date can not be empty. Please check "Present" if there is no End date',
          });
        }
      }
    });
  }
  ngOnInit(): void {
    if (this.fieldValue) {
      let valueArray = this.fieldValue.replace(/ /g, '').split('|');
      if (valueArray.length > 0) {
        this.startDateValue.setValue(new Date(valueArray[0]));
        if (valueArray.length == 2) {
          if (valueArray[1].localeCompare('Present', 'en', { sensitivity: 'base' }) == 0) {
            this.noEndDate.setValue(true);
          } else {
            this.endDateValue.setValue(new Date(valueArray[1]));
          }
        }
        this.setStartDateValidationMessages();
      }
    }
  }

  updateStartDate() {
    this.setStartDateValidationMessages();
    this.changeValue();
  }

  updateEndDate() {
    this.setEndDateValidationMessages();
    this.changeValue();
  }

  setStartDateValidationMessages() {
    if (
      this.startDate &&
      this.endDate &&
      moment.utc(new Date(this.startDate)).isAfter(moment.utc(new Date(this.endDate)))
    ) {
      this.endDateValue.setErrors(null);
      this.startDateValue.setErrors(null);
      this.startDateValue.setErrors({
        startDateBeforeEndDate: 'Start Date cannot be after End Date',
      });
    } else {
      if (!this.startDateValue.errors?.startDateRequired) {
        this.startDateValue.setErrors(null);
      }
      if (!this.endDateValue.errors?.endDateRequired) {
        this.endDateValue.setErrors(null);
      }
    }
  }

  setEndDateValidationMessages() {
    if (
      this.startDate &&
      this.endDate &&
      moment.utc(new Date(this.startDate)).isAfter(moment.utc(new Date(this.endDate)))
    ) {
      this.endDateValue.setErrors(null);
      this.startDateValue.setErrors(null);
      this.endDateValue.setErrors({
        startDateBeforeEndDate: 'Start Date cannot be after End Date',
      });
    } else {
      if (!this.endDateValue.errors?.endDateRequired) {
        this.endDateValue.setErrors(null);
      }
      if (!this.startDateValue.errors?.startDateRequired) {
        this.startDateValue.setErrors(null);
      }
    }
  }

  updatePresent() {
    this.changeValue();
  }

  changeValue() {
    this.noEndDate.markAsDirty();
    let emitValue = null;
    if (this.startDate) {
      if (this.present) {
        emitValue = this.startDate + '|Present';
      } else if (this.endDate) {
        emitValue = this.startDate + '|' + this.endDate;
      } else {
        emitValue = this.startDate;
      }
    } else if (this.endDate) {
      emitValue = '|' + this.endDate;
    } else if (this.present) {
      emitValue = '|Present';
    }
    this.dateChanged.emit(emitValue);
  }
}
